import React from 'react';
import useGetSimulationPavillonInformationQuery from './hooks/useGetSimulationPavillonInformationQuery.js';
import SimulationPavillonInformationForm from './SimulationPavillonInformationForm.jsx';
import { Loading } from '@fasstech/middle-design-system';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';

const SimulationPavillonInformation = ({
  middleFeatures,
  phoneIndicatives,
  regimeObligatoire,
  professionalSituations,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber
}) => {
  const { getSimulationPavillonInformation, loading: isLoadingGetSimulationPavillonInformation } =
    useGetSimulationPavillonInformationQuery();

  if (isLoadingGetSimulationPavillonInformation) {
    return <Loading />;
  }

  return (
    <SimulationPavillonInformationForm
      getInformations={getSimulationPavillonInformation}
      middleFeatures={middleFeatures}
      phoneIndicatives={phoneIndicatives}
      regimeObligatoire={regimeObligatoire}
      professionalSituations={professionalSituations}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      getMiddleNumber={getMiddleNumber}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SimulationPavillonInformation);
